/* ==========================================================================
   SURGE PEPT — affiliate portal v2 (dashboard)
   Hoort bij assets/affiliate-portal.css en templates/page.affiliates.json.

   Deze view is 1:1 gebouwd naar docs/affiliate/portal-mockup.html: banner,
   vier stat-tiles, de gesegmenteerde tier-meter, referred orders, de
   payout-kaart met vergrendelde staat, de code-kaart en de maandgrafiek.
   Alle markup zit onder .spx__dash zodat de mockup-CSS gescopt blijft.

   Gegevensbron: de worker geeft op action 'summary' het /me-object terug,
   inclusief (fase 2) `payoutEligible` + `payoutBlockReason` en het
   config-gedreven `program`-blok (tier-ladder, base/effective rate).

   De tekenflow (fase 3) bestaat nog niet: zolang die er niet is levert de
   worker payoutEligible=false met reden 'agreement_unsigned', dus het
   dashboard toont de vergrendelde staat. Events lopen via delegatie op de
   root, zodat listeners nooit opnieuw gekoppeld hoeven te worden.
   ========================================================================== */

(function () {
  'use strict';

  var cfgEl = document.getElementById('spx-config');
  var root  = document.getElementById('spxRoot');
  if (!cfgEl || !root) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent || cfgEl.innerHTML); }
  catch (e) { return; }

  var LOCALE = 'en-GB';
  var DAY_MS = 864e5;

  /* ── formattering ──────────────────────────────────────────────────── */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return '€' + (Number(cents || 0) / 100).toLocaleString(LOCALE, {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }
  function money0(cents) {
    return '€' + Math.round(Number(cents || 0) / 100).toLocaleString(LOCALE);
  }
  function moneyK(cents) {
    var v = Number(cents || 0) / 100;
    if (Math.abs(v) >= 1000) return '€' + (v / 1000).toLocaleString(LOCALE, { maximumFractionDigits: 1 }) + 'k';
    return '€' + Math.round(v).toLocaleString(LOCALE);
  }
  function pct(n) { return (Math.round(Number(n || 0) * 10) / 10) + '%'; }
  function fmtDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString(LOCALE, { day: '2-digit', month: 'short', year: 'numeric' });
  }
  function fmtMonthShort(key) {
    var p = String(key).split('-');
    return new Date(Date.UTC(+p[0], +p[1] - 1, 1))
      .toLocaleDateString(LOCALE, { month: 'short' }).toUpperCase();
  }
  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return 'SP';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  function daysUntil(iso) {
    if (!iso) return 0;
    return Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / DAY_MS));
  }

  /* ── iconen (paden letterlijk uit de mockup) ───────────────────────── */

  var ICON = {
    alert: '<path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    x:     '<path d="M18 6 6 18M6 6l12 12"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    lock:  '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
    star:  '<path d="M12 2 15 9l7 .6-5.3 4.6L18.2 21 12 17.3 5.8 21l1.5-6.8L2 9.6 9 9z"/>'
  };
  function svg(name) { return '<svg viewBox="0 0 24 24">' + ICON[name] + '</svg>'; }

  /* ── statuschips (worker-status → mockup-chip, altijd icoon + tekst) ── */

  var STATUS = {
    cleared:    { cls: 'good', icon: 'check', label: 'Approved'     },
    waiting:    { cls: 'warn', icon: 'clock', label: 'Holding'      },
    refunded:   { cls: 'crit', icon: 'x',     label: 'Refunded'     },
    cancelled:  { cls: 'crit', icon: 'x',     label: 'Cancelled'    },
    self:       { cls: 'idle', icon: null,    label: 'Own order'    },
    zero:       { cls: 'idle', icon: null,    label: 'Not eligible' },
    /* Handmatige correctie door ons: een eigen regel, zodat de optelling van
       de partner blijft kloppen met zijn saldo. */
    adjustment: { cls: 'info', icon: null,    label: 'Adjustment'   }
  };
  function statusChip(status) {
    var s = STATUS[status] || STATUS.zero;
    return '<span class="chip chip--' + s.cls + '">' + (s.icon ? svg(s.icon) : '') + esc(s.label) + '</span>';
  }
  function counts(status) { return status === 'cleared' || status === 'waiting'; }

  var TIER_PIP = ['pip--s', 'pip--si', 'pip--g', 'pip--p'];

  /* ── state ─────────────────────────────────────────────────────────── */

  var store = {
    load: 'loading',   // loading | ok | error
    error: null,
    data: null,
    fetchedAt: null,
    notice: null,
    armed: false,
    busy: false,
    view: 'dashboard', // dashboard | agreement
    agreement: null,   // gecachte agreementCurrent-respons
    signing: false,
    signErrors: []
  };

  var COUNTRIES = ['Netherlands', 'Belgium', 'Germany', 'France', 'Spain', 'Italy',
    'Denmark', 'Sweden', 'Ireland', 'Poland', 'Austria', 'Portugal', 'Other'];

  /* ── netwerk ───────────────────────────────────────────────────────── */

  /**
   * Eén verzoek aan de worker. Geeft altijd een object terug, nooit een
   * uitzondering — ook als het misgaat.
   *
   * Dit stond er eerst als `.then(r => r.json())` met één vangnet eromheen.
   * Gevolg: elke storing, wat hij ook was, kwam als "de server antwoordde
   * niet" op het scherm. Toen de worker een keer een HTML-foutpagina van
   * Cloudflare terugstuurde klopte die melding niet eens — er wás een
   * antwoord, het was alleen geen JSON. Dat verschil kost diagnosetijd, dus
   * we houden het nu apart:
   *
   *   network       fetch zelf faalde — geen antwoord (offline, DNS, CORS)
   *   bad_response  wél een antwoord, maar geen JSON (foutpagina, proxy)
   *   <worker>      JSON van de worker; die vertelt zelf wat er misging
   */
  /**
   * Een antwoord duiden. Apart gezet omdat er twee wegen naartoe leiden: de
   * gewone fetch hieronder, en het verzoek dat de paginakop al heeft gestart
   * voordat dit bestand binnen was. Beide moeten dezelfde foutmeldingen
   * opleveren, anders gaat die winst ten koste van diagnose.
   */
  function duidAntwoord(ok, status, ctype, text) {
    var data = null;
    try { data = JSON.parse(text); } catch (e) {}

    if (data && typeof data === 'object') {
      /* De worker antwoordt ook bij een fout in JSON, mét `step`. Die
         laten we intact; alleen de HTTP-status voegen we toe. */
      if (!ok) {
        data.httpStatus = status;
        if (!data.error) data.error = 'http_' + status;
      }
      return data;
    }

    return {
      error: 'bad_response',
      httpStatus: status,
      contentType: ctype || 'onbekend',
      /* Tags eruit, dan blijft de leesbare kern van een foutpagina over
         ("Worker threw exception", "Error 1101"). */
      bodySnippet: String(text || '').replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ').trim().slice(0, 160)
    };
  }

  function api(action, extra) {
    /* De paginakop vuurt het eerste summary-verzoek al af zodra de HTML er is.
       Dit bestand is 64 kB en moet eerst gedownload en uitgevoerd worden; die
       tijd stond voorheen vóór het verzoek in plaats van ernaast. Pakken we
       hier het lopende verzoek op, dan is het antwoord er vaak al.

       Mislukt de vooruitgestuurde poging of ontbreekt hij, dan valt hij
       hieronder gewoon terug op de normale weg. */
    if (action === 'summary' && !extra && window.__spxVooraf) {
      var vooraf = window.__spxVooraf;
      window.__spxVooraf = null;              /* eenmalig, verversen gaat normaal */
      return vooraf.then(function (p) {
        if (!p) return api('summary');
        if (p.netErr) return { error: 'network', reason: String(p.netErr).slice(0, 160) };
        return duidAntwoord(p.ok, p.status, p.ctype, p.text);
      }, function () { return api('summary'); });
    }

    var body = { action: action, cid: CFG.cid, ts: CFG.ts, sig: CFG.sig };
    if (extra) for (var k in extra) if (extra.hasOwnProperty(k)) body[k] = extra[k];
    return fetch(CFG.worker, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      var ctype = '';
      try { ctype = r.headers.get('content-type') || ''; } catch (e) {}
      /* Eerst als tekst lezen: bij een HTML-foutpagina gooit r.json() en ben
         je precies het bewijs kwijt dat je nodig hebt. */
      return r.text().then(function (text) {
        return duidAntwoord(r.ok, r.status, ctype, text);
      });
    }, function (err) {
      return { error: 'network', reason: String((err && err.message) || err).slice(0, 160) };
    });
  }

  function shareLink() {
    return CFG.shop + '/discount/' + encodeURIComponent(store.data.code);
  }

  /* ── deelrenderers ─────────────────────────────────────────────────── */

  function h(id) { return document.getElementById(id); }
  function set(id, html) { var el = h(id); if (el) el.innerHTML = html; }

  function fullMsg(title, text, actions) {
    root.innerHTML =
      '<div class="spx__card"><div class="spx__msg">' +
        '<b>' + esc(title) + '</b><p>' + esc(text) + '</p>' +
        (actions ? '<div class="spx__msgact">' + actions + '</div>' : '') +
      '</div></div>';
  }

  function skeleton() {
    var s = '';
    for (var i = 0; i < 3; i++) {
      s += '<div class="spx__card">' +
        '<div class="spx__skel" style="width:38%;height:26px"></div>' +
        '<div class="spx__skel" style="width:62%"></div>' +
        '<div class="spx__skel" style="width:48%"></div></div>';
    }
    root.innerHTML = s;
  }

  function whoHtml(d) {
    var prog = d.program || {};
    var pip = TIER_PIP[prog.tierIndex || 0] || 'pip--s';
    /* Toon met welk account je kijkt — de mockup zet daar het e-mailadres. */
    var who = d.firstName || d.email || d.code;
    return '<div class="who">' +
      '<span class="chip chip--idle"><span class="pip ' + pip + '"></span>' +
        esc(prog.tierName || 'Starter') + ' partner</span>' +
      (d.firstName ? '<span>' + esc(d.firstName) + '</span>' : '') +
      (d.email ? '<span>' + esc(d.email) + '</span>' : '') +
      '<span class="who__av">' + esc(initials(who)) + '</span>' +
    '</div>';
  }

  /**
   * De eerstvolgende datum waarop er commissie vrijkomt, of null.
   *
   * De worker zet per wachtende order een `clearsAt`. De vroegste daarvan is
   * het moment waarop er weer iets te halen valt.
   */
  function eersteVrijkomdatum(d) {
    var vroegste = null;
    (d && d.rows || []).forEach(function (r) {
      if (!r || r.status !== 'waiting' || !r.clearsAt) return;
      var t = new Date(r.clearsAt).getTime();
      if (!isFinite(t)) return;
      if (vroegste === null || t < vroegste) vroegste = t;
    });
    return vroegste;
  }

  function datumKort(ms) {
    try {
      return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    } catch (e) { return null; }
  }

  /**
   * Korte toelichting onder de vergrendelde "Available"-tile, per reden.
   *
   * `below_minimum` is de reden die de worker teruggeeft zodra het beschikbare
   * saldo onder het minimum ligt — ook wanneer dat komt doordat álles nog in
   * het retourvenster zit. "Keep earning" is dan het verkeerde advies: er valt
   * niets te verdienen, er valt te wachten. Een partner met genoeg commissie
   * in holding ging daardoor harder zijn best doen terwijl hij alleen een paar
   * dagen had hoeven zitten.
   *
   * Daarom eerst kijken of er iets in holding staat, en zo ja de datum noemen.
   */
  function lockReasonLabel(reason, d) {
    if (reason === 'tax_form_missing') return 'Locked until we have your tax form';
    if (reason === 'inactive')         return 'Account is not active';
    if (reason === 'rate_changed')     return 'Locked until you sign at your new rate';
    if (reason === 'below_minimum') {
      var wacht = d && d.pendingCents;
      if (wacht > 0) {
        var datum = datumKort(eersteVrijkomdatum(d));
        return datum ? (money(wacht) + ' clears on ' + datum)
                     : (money(wacht) + ' is still in the refund window');
      }
      return 'Keep earning to reach the minimum';
    }
    return 'Locked until agreement is signed';   // agreement_unsigned / agreement_outdated
  }

  function bannerHtml(d) {
    if (d.payoutEligible) {
      return '<div class="banner banner--ok">' +
        '<div class="banner__ic">' + svg('check') + '</div>' +
        '<div><b>Agreement signed — payouts unlocked</b>' +
        '<p>Your balance is available to withdraw. A countersigned copy is available under Documents.</p></div>' +
        '<button type="button" class="btn btn--ghost btn--sm" data-act="pdf">Download PDF</button>' +
      '</div>';
    }

    var reason = d.payoutBlockReason;

    /* Tweede grendel (WIJZIGINGEN-2 §2): een eigen staat, NIET samengevoegd met
       de handtekening. De partner heeft al getekend; hier geen teken-knop. */
    if (reason === 'tax_form_missing') {
      return '<div class="banner">' +
        '<div class="banner__ic">' + svg('alert') + '</div>' +
        '<div><b>One step before your first payout</b>' +
        '<p>Email us your VAT or Chamber of Commerce number to unlock payouts. ' +
        'Your balance keeps accruing.</p></div>' +
      '</div>';
    }

    /* Het tarief is gewijzigd na ondertekening. Dit is een eigen staat en geen
       variant van "ongetekend": de partner heeft wél getekend, alleen niet op
       dit tarief. Zonder deze tak viel hij door naar de lege return hieronder —
       en dan stond hij op slot zonder banner, dus zonder knop om iets aan zijn
       situatie te doen. Een grendel zonder uitweg is erger dan geen grendel. */
    if (reason === 'rate_changed') {
      return '<div class="banner">' +
        '<div class="banner__ic">' + svg('alert') + '</div>' +
        '<div><b>Your commission rate changed — signature required</b>' +
        '<p>' + esc(d.payoutBlockMessage ||
          'Your base commission rate was changed after you signed. Sign the Agreement again at ' +
          'your new rate to unlock payouts.') +
        ' Commission already confirmed is unaffected.</p></div>' +
        '<button type="button" class="btn" data-act="review">Review &amp; sign ' + svg('arrow') + '</button>' +
      '</div>';
    }

    /* Overeenkomst niet (meer) getekend: de tekenflow. */
    if (reason === 'agreement_unsigned' || reason === 'agreement_outdated') {
      var isNew = reason === 'agreement_outdated';
      return '<div class="banner">' +
        '<div class="banner__ic">' + svg('alert') + '</div>' +
        '<div><b>' + (isNew ? 'New agreement version — signature required'
                            : 'Signature required before your first payout') + '</b>' +
        '<p>' + (isNew
          ? 'A new version of the Affiliate Partner Agreement has been published. Sign it to unlock ' +
            'payouts again. Commission already confirmed is unaffected.'
          : 'Your dashboard, commission and tier progress are fully active — you keep earning. ' +
            'Payouts stay on hold until the SURGE Pept Affiliate Partner Agreement is signed.') + '</p></div>' +
        '<button type="button" class="btn" data-act="review">Review &amp; sign ' + svg('arrow') + '</button>' +
      '</div>';
    }

    /* below_minimum / inactive: geen blokkade-banner — de payout-kaart toont de reden. */
    return '';
  }

  function tilesHtml(d) {
    var prog = d.program || {};
    var locked = !d.payoutEligible;
    var uplift = Math.max(0, Math.round((prog.effectivePct || 0) - (prog.basePct || 0)));
    return '<div class="tiles">' +
      '<div class="tile">' +
        '<div class="tile__k">Qualifying revenue</div>' +
        '<div class="tile__v">' + money0(d.grossCents) + '</div>' +
        '<div class="tile__f">Lifetime · net of refunds</div>' +
      '</div>' +
      '<div class="tile">' +
        '<div class="tile__k">Commission earned</div>' +
        '<div class="tile__v">' + money(d.lifetimeCents) + '</div>' +
        '<div class="tile__f">All tiers combined</div>' +
      '</div>' +
      '<div class="tile' + (locked ? ' tile--locked' : '') + '">' +
        '<div class="tile__k">' + (locked ? svg('lock') : '') + 'Available to pay out</div>' +
        '<div class="tile__v">' + money(d.availableCents) + '</div>' +
        '<div class="tile__f">' + (locked ? lockReasonLabel(d.payoutBlockReason, d) : 'Ready to withdraw') + '</div>' +
      '</div>' +
      '<div class="tile">' +
        '<div class="tile__k">Current rate</div>' +
        '<div class="tile__v" style="color:var(--ice)">' + pct(prog.effectivePct) + '</div>' +
        '<div class="tile__f">Base ' + pct(prog.basePct) + (uplift ? ' + ' + uplift + ' tier step' + (uplift === 1 ? '' : 's') : '') + '</div>' +
      '</div>' +
    '</div>';
  }

  function tierCardHtml(d) {
    var prog = d.program || {};
    var tiers = prog.tiers || [];
    if (!tiers.length) return '';
    var top = tiers[tiers.length - 1].thresholdCents || 1;
    var cum = prog.cumulativeRevenueCents || 0;
    var idx = prog.tierIndex || 0;
    var pip = TIER_PIP[idx] || 'pip--s';

    /* Segmenten tussen opeenvolgende drempels; breedte ∝ euro-span. */
    var segs = '', marks = '', i;
    for (i = 0; i < tiers.length - 1; i++) {
      var span = tiers[i + 1].thresholdCents - tiers[i].thresholdCents;
      var w = (span / top * 100);
      var fill = Math.max(0, Math.min(100, (cum - tiers[i].thresholdCents) / span * 100));
      segs += '<div class="meter__seg" style="width:' + w.toFixed(2) + '%">' +
        '<div class="meter__fill" style="width:' + Math.round(fill) + '%"></div></div>';
    }
    for (i = 0; i < tiers.length; i++) {
      var cls = i < idx ? 'mk--done' : (i === idx ? 'mk--now' : 'mk--todo');
      var style = i < tiers.length - 1
        ? 'width:' + ((tiers[i + 1].thresholdCents - tiers[i].thresholdCents) / top * 100).toFixed(2) + '%'
        : 'width:112px';
      marks += '<div class="mk ' + cls + '" style="' + style + '">' +
        '<b>' + esc(tiers[i].name) + '</b>' + money0(tiers[i].thresholdCents) + ' · ' + pct(tiers[i].effectivePct) +
      '</div>';
    }

    var head;
    if (prog.nextThresholdCents != null) {
      var need = Math.max(0, prog.nextThresholdCents - cum);
      head = '<div class="tierhead">' +
        '<div><div class="mini">Toward ' + esc(prog.nextTierName) + '</div>' +
          '<div class="tierhead__now">' + money0(cum) +
          ' <span style="color:var(--mute);font-size:15px">/ ' + money0(prog.nextThresholdCents) + '</span></div></div>' +
        '<div style="text-align:right"><div class="mini">Still needed</div>' +
          '<div class="tierhead__now" style="color:var(--ice)">' + money0(need) + '</div></div>' +
      '</div>';
    } else {
      head = '<div class="tierhead">' +
        '<div><div class="mini">Highest tier reached</div>' +
          '<div class="tierhead__now">' + money0(cum) + '</div></div>' +
        '<div style="text-align:right"><div class="mini">Rate</div>' +
          '<div class="tierhead__now" style="color:var(--ice)">' + pct(prog.effectivePct) + '</div></div>' +
      '</div>';
    }

    var uplift = Math.max(0, Math.round((prog.effectivePct || 0) - (prog.basePct || 0)));
    return '<div class="card" style="margin-bottom:16px">' +
      '<div class="card__h"><div><h3>Tier progress</h3>' +
        '<p class="sub">Every tier adds +1% commission. Uplift caps at +3 above your base rate.</p></div>' +
        '<span class="chip chip--info">' + svg('star') + esc(prog.tierName) + '</span>' +
      '</div>' +
      '<div class="card__b">' + head +
        '<div class="meter">' + segs + '</div>' +
        '<div class="meter__marks">' + marks + '</div>' +
        '<div class="tierfoot">' +
          '<div>Your base rate<b>' + pct(prog.basePct) + '</b></div>' +
          '<div>Tier uplift<b style="color:var(--green)">+' + uplift + '%</b></div>' +
          '<div>Effective now<b style="color:var(--ice)">' + pct(prog.effectivePct) + '</b></div>' +
          '<div>Your maximum<b>' + pct(prog.maxRatePct) + '</b></div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function ordersCardHtml(d) {
    var since = Date.now() - 30 * DAY_MS;
    var rows = (d.rows || []).filter(function (r) {
      return new Date(r.createdAt).getTime() >= since;
    }).slice(0, 8);

    var body;
    if (!rows.length) {
      body = '<tbody><tr><td colspan="6" style="padding:26px 12px;text-align:center;color:var(--mute)">' +
        'No orders with your code in the last 30 days.</td></tr></tbody>';
    } else {
      body = '<tbody>' + rows.map(function (r) {
        /* Een correctieregel heeft geen orderbedrag en geen tarief — die
           kolommen blijven leeg in plaats van een verzonnen 0% te tonen.
           Het bedrag draagt een teken, zodat een terugvordering herkenbaar is. */
        if (r.type === 'adjustment' || r.status === 'adjustment') {
          var amt = r.commissionCents || 0;
          return '<tr>' +
            '<td>' + esc(r.order) + '</td>' +
            '<td class="mini">' + esc(fmtDate(r.createdAt)) + '</td>' +
            '<td class="num spx__off">—</td>' +
            '<td class="num spx__off">—</td>' +
            '<td class="num"' + (amt < 0 ? ' style="color:var(--mag)"' : '') + '>' +
              (amt > 0 ? '+' : '') + money(amt) + '</td>' +
            '<td>' + statusChip('adjustment') + '</td>' +
          '</tr>';
        }
        var ok = counts(r.status);
        return '<tr>' +
          '<td class="num">' + esc(r.order) + '</td>' +
          '<td class="mini">' + esc(fmtDate(r.createdAt)) + '</td>' +
          '<td class="num">' + money(r.orderCents) + '</td>' +
          '<td class="num">' + pct(r.ratePct) + '</td>' +
          '<td class="num">' + (ok ? money(r.commissionCents) : '—') + '</td>' +
          '<td>' + statusChip(r.status) + '</td>' +
        '</tr>';
      }).join('') + '</tbody>';
    }

    return '<div class="card">' +
      '<div class="card__h"><h3>Referred orders</h3><span class="mini">Last 30 days</span></div>' +
      '<div class="card__b" style="padding:6px 6px 10px">' +
        '<div class="tblwrap"><table>' +
          '<thead><tr><th>Order</th><th>Date</th><th class="num">Revenue</th>' +
          '<th class="num">Rate</th><th class="num">Commission</th><th>Status</th></tr></thead>' +
          body +
        '</table></div>' +
        '<p class="hint" style="padding:0 12px">“Holding” = inside the ' + (d.clearDays || 14) +
        '-day refund window. Commission is confirmed once the window closes.</p>' +
      '</div>' +
    '</div>';
  }

  /**
   * De tax-form-actie in de vergrendelde payout-kaart.
   *
   * Bewust GEEN upload: een W-9 bevat een SSN, een W-8BEN een buitenlands
   * fiscaal nummer. Die documenten horen in de boekhouding, niet in dit
   * portaal (WIJZIGINGEN-2 §2). De knop opent een vooringevulde mail in de
   * eigen mailclient; de partner hangt het bestand daar zelf aan. Met "I've
   * sent it" meldt hij dat, zodat de regel in het paneel op 'ter controle'
   * komt. Dat ontgrendelt niets — een admin legt type en datum vast.
   */
  function taxFormActionHtml(d) {
    var tf = d.taxForm || {};
    var inbox = d.taxInbox || 'info@surgepept.com';

    if (tf.declaredSentAt) {
      return '<div class="lockrow" style="border-style:solid;border-color:rgba(0,166,240,.45);' +
        'background:rgba(0,166,240,.06)">' + svg('clock') +
        '<span>Sent by email on ' + esc(fmtDate(tf.declaredSentAt)) +
        ' — awaiting our review. We’ll unlock payouts once we’ve checked it.</span></div>';
    }

    var subject = 'Tax details — affiliate ' + (d.code || '');
    var body = 'Hello SURGE Pept,\n\n' +
      'Attached is proof of my tax registration for the affiliate programme.\n\n' +
      'Affiliate code: ' + (d.code || '') + '\n' +
      'Account: ' + (d.email || '') + '\n' +
      'VAT / tax number: \n' +
      'Company or Chamber of Commerce no. (if any): \n' +
      'Document attached: (VAT registration / CoC extract / W-9 / W-8BEN)\n\n' +
      'Kind regards,\n' + (d.firstName || '');
    var href = 'mailto:' + inbox +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);

    return '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px">' +
        '<a class="btn btn--sm" style="flex:1;min-width:150px;text-decoration:none" href="' + esc(href) + '">' +
          'Send tax details ' + svg('arrow') + '</a>' +
        '<button type="button" class="btn btn--ghost btn--sm" data-act="taxsent" style="flex:1;min-width:130px">' +
          'I’ve sent it</button>' +
      '</div>' +
      '<p class="hint">Outside the EU: a W-9 or W-8BEN. Nothing is uploaded here — ' +
      'it stays in your email to us.</p>';
  }

  function payoutCardHtml(d) {
    var min = d.minimumCents || 5000;
    var avail = d.availableCents || 0;
    var open = d.pendingRequestCents || 0;

    var inner;
    if (!d.payoutEligible) {
      /* Eigen staat per reden, niet één samengevoegde. Een partner die net
         getekend heeft en dan nog steeds "teken de overeenkomst" leest, denkt
         dat het tekenen niet is aangekomen. De toon blijft gelijk: het saldo
         loopt door, er gaat niets verloren. */
      var lockText;
      if (d.payoutBlockReason === 'tax_form_missing') {
        lockText = 'Email us your VAT or Chamber of Commerce number to unlock payouts.';
      } else if (d.payoutBlockReason === 'below_minimum' && (d.pendingCents || 0) > 0) {
        /* De worker zegt hier "keep earning to reach the minimum". Dat klopt
           technisch — het beschikbare saldo is te laag — maar de oorzaak is
           dat alles nog in het retourvenster zit. Dan is wachten het antwoord,
           niet harder werken. */
        var vrij = datumKort(eersteVrijkomdatum(d));
        lockText = money(d.pendingCents) + ' is still inside the ' +
          (d.clearDays || 14) + '-day refund window' +
          (vrij ? ' and clears on ' + vrij : '') + '. ' +
          'Nothing is lost — it moves to your available balance by itself.';
      } else if (d.payoutBlockMessage) {
        lockText = d.payoutBlockMessage;
      } else {
        lockText = 'Sign the Affiliate Partner Agreement to enable payouts. ' +
                   'Your balance keeps accruing in the meantime — nothing is lost.';
      }
      inner = '<div>' +
        '<button type="button" class="btn" disabled style="width:100%;margin-top:14px">' +
          svg('lock') + 'Payout locked</button>' +
        '<div class="lockrow">' + svg('lock') +
          '<span>' + esc(lockText) + '</span></div>' +
        (d.payoutBlockReason === 'tax_form_missing' ? taxFormActionHtml(d) : '') +
      '</div>';
    } else if (open > 0) {
      inner = '<div><button type="button" class="btn" disabled style="width:100%;margin-top:14px">' +
        'Request in progress</button>' +
        '<p class="hint">Your request for ' + money(open) + ' is queued.</p></div>';
    } else if (avail < min) {
      inner = '<div><button type="button" class="btn" disabled style="width:100%;margin-top:14px">' +
        'Request payout</button>' +
        '<p class="hint">' + money(min - avail) + ' to go until you reach the ' + money(min) + ' minimum.</p></div>';
    } else {
      inner = '<div><button type="button" class="btn" data-act="payout" style="width:100%;margin-top:14px">' +
        (store.armed ? 'Confirm ' + money(avail) : 'Request ' + money(avail)) + ' ' + svg('arrow') + '</button>' +
        (store.armed
          ? '<p class="hint" style="color:var(--amber)">Press once more to send — it cannot be withdrawn afterwards.</p>'
          : '<p class="hint">Paid by bank transfer within 10 business days of approval.</p>') +
      '</div>';
    }

    return '<div class="card" style="margin-bottom:16px">' +
      '<div class="card__h"><h3>Request payout</h3></div>' +
      '<div class="card__b">' +
        '<div class="tile__k">Available balance</div>' +
        '<div class="tile__v" style="font-size:30px' + (d.payoutEligible ? '' : ';color:var(--mute)') + '">' + money(avail) + '</div>' +
        '<p class="sub">Minimum payout ' + money0(min) + ' · paid by bank transfer within 10 business days of approval.</p>' +
        inner +
      '</div>' +
    '</div>';
  }

  /**
   * Een bedrag in hele euro's, of met centen als dat nodig is. 12,75 moet
   * niet als 13 op het scherm komen: dan klopt het rekenvoorbeeld niet meer.
   */
  function euro(bedrag) {
    var afgerond = Math.round(bedrag * 100) / 100;
    return '€' + (afgerond % 1 === 0 ? String(afgerond)
                                     : afgerond.toFixed(2).replace('.', ','));
  }

  function codeCardHtml(d) {
    /* Deze twee stonden hardcoded op 10 %. Wie op 15 % zat, vertelde zijn
       publiek daardoor de verkeerde korting — en rekende zichzelf de verkeerde
       commissie voor. Beide komen nu uit de gegevens: het kortingspercentage
       leest de worker uit Shopify, het commissietarief is het effectieve tarief
       inclusief tier-uplift. */
    var kortingPct = (typeof d.discountPct === 'number') ? d.discountPct : null;
    var commissiePct = (d.program && d.program.effectivePct) || 0;

    var kortingZin = (kortingPct !== null)
      ? 'Gives your audience ' + pct(kortingPct) + ' off. Every order using it is attributed to you.'
      : 'Every order using this code is attributed to you.';

    /* Rekenvoorbeeld op €100, met dezelfde grondslag als clausule 4 van de
       overeenkomst: commissie ná aftrek van de korting. Die definitie is
       juridisch correct maar leest verkeerd zonder voorbeeld (WIJZIGINGEN-2 §1).
       Zonder kortingspercentage laten we het weg in plaats van te gokken. */
    var voorbeeld = '';
    if (kortingPct !== null && commissiePct > 0) {
      var betaalt = 100 - kortingPct;
      var verdient = betaalt * commissiePct / 100;
      voorbeeld = '<p class="mini" style="margin-top:10px;color:var(--dim)">' +
        'On a €100 order with your code, the customer pays ' + euro(betaalt) +
        ' and you earn ' + euro(verdient) + '.</p>';
    }

    return '<div class="card" style="margin-bottom:16px">' +
      '<div class="card__h"><h3>Your code &amp; link</h3></div>' +
      '<div class="card__b">' +
        '<div class="tile__k">Discount code</div>' +
        '<div class="tile__v" style="font-size:22px;font-family:var(--mono);color:var(--ice)">' + esc(d.code) + '</div>' +
        '<p class="sub">' + esc(kortingZin) + '</p>' +
        '<div style="margin-top:12px"><div class="tile__k">Referral link</div>' +
          '<div class="mini" style="margin-top:6px;word-break:break-all;color:var(--dim)">' + esc(shareLink()) + '</div></div>' +
        voorbeeld +
        '<button type="button" class="btn btn--ghost btn--sm" data-act="copylink" style="width:100%;margin-top:14px">Copy link</button>' +
      '</div>' +
    '</div>';
  }

  function sparkHtml(d) {
    var series = (d.series || []).slice(-6);
    var max = 0, i;
    for (i = 0; i < series.length; i++) if (series[i].revenueCents > max) max = series[i].revenueCents;

    var bars = series.map(function (m, idx) {
      var last = idx === series.length - 1;
      var pctH = max > 0 ? Math.max(4, Math.round(m.revenueCents / max * 100)) : 4;
      return '<div class="spark__b' + (last ? ' on' : '') + '" style="height:' + pctH + '%">' +
        (last ? '<span class="spark__val">' + moneyK(m.revenueCents) + '</span>' : '') + '</div>';
    }).join('');
    var labs = series.map(function (m) {
      return '<span>' + esc(fmtMonthShort(m.month)) + '</span>';
    }).join('');

    return '<div class="card">' +
      '<div class="card__h"><h3>Revenue by month</h3></div>' +
      '<div class="card__b">' +
        (series.length
          ? '<div class="spark">' + bars + '</div><div class="spark__lab">' + labs + '</div>'
          : '<p class="sub" style="margin:0">No monthly data yet — this fills up as orders come in.</p>') +
      '</div>' +
    '</div>';
  }


  /* ── afschrift ───────────────────────────────────────────────────────
     Het scherm waarop een partner zijn eigen saldo kan natellen. Elke
     beweging op één rij, oudste onderaan, met een lopend saldo. De bovenste
     regel hoort gelijk te zijn aan het bevestigde saldo — kan iemand dat niet
     natellen, dan is er iets mis, en dat willen we zien in plaats van
     wegpoetsen. */

  var STMT = {
    commission: { cls: 'good', icon: 'check', label: 'Commission' },
    pending:    { cls: 'warn', icon: 'clock', label: 'Holding' },
    reversal:   { cls: 'crit', icon: 'x',     label: 'Reversed' },
    adjustment: { cls: 'info', icon: null,    label: 'Adjustment' },
    payout:     { cls: 'idle', icon: null,    label: 'Paid out' },
    request:    { cls: 'warn', icon: 'clock', label: 'Requested' }
  };

  function signedMoney(cents) {
    var n = Number(cents || 0);
    if (n === 0) return '—';
    return (n > 0 ? '+' : '−') + money(Math.abs(n));
  }

  function statementCardHtml(d) {
    var lines = d.statement || [];
    var t = d.statementTotals || {};

    if (!lines.length) {
      return '<div class="card" style="margin-top:16px"><div class="card__h"><h3>Statement</h3></div>' +
        '<div class="card__b"><p style="text-align:center;color:var(--mute);padding:22px 0;margin:0">' +
        'No movements yet.<br><span class="hint">Every commission, correction and payout will appear here with a running balance.</span>' +
        '</p></div></div>';
    }

    var rows = lines.slice(0, 60).map(function (l) {
      var s = STMT[l.type] || STMT.adjustment;
      var bedrag = l.type === 'reversal' ? '—' : signedMoney(l.amountCents);
      var kleur = (l.amountCents || 0) < 0 ? ' style="color:var(--mag)"'
                : ((l.amountCents || 0) > 0 && l.counts) ? ' style="color:var(--green)"' : '';
      /* Een regel die niet meetelt krijgt een gedimd saldo: het getal ernaast
         is niet veranderd, en dat moet je kunnen zien. */
      var saldo = l.counts
        ? '<b>' + money(l.balanceCents) + '</b>'
        : '<span class="spx__off">' + money(l.balanceCents) + '</span>';
      var detail = (l.type === 'pending' && l.detail) ? 'clears ' + fmtDate(l.detail) : (l.detail || '');
      /* Orderwaarde en tarief horen erbij: zonder die twee kan een partner
         niet nagaan waaróm de commissie is wat hij is. */
      var omzet = (l.orderCents != null && l.orderCents > 0) ? money(l.orderCents) : '—';
      var tarief = l.rateBps ? pct(l.rateBps / 100) : '—';
      return '<tr>' +
        '<td class="mini">' + esc(fmtDate(l.at)) + '</td>' +
        '<td>' + esc(l.label || s.label) +
          (detail ? '<div class="mini">' + esc(detail) + '</div>' : '') + '</td>' +
        '<td class="mini">' + esc(l.ref || '—') + '</td>' +
        '<td class="num">' + omzet + '</td>' +
        '<td class="num">' + tarief + '</td>' +
        '<td class="num"' + kleur + '>' + bedrag + '</td>' +
        '<td class="num">' + saldo + '</td>' +
        '<td><span class="chip chip--' + s.cls + '">' +
          (s.icon ? svg(s.icon) : '') + esc(s.label) + '</span></td>' +
      '</tr>';
    }).join('');

    /* De aansluitcontrole. Klopt hij, dan zeggen we het rustig; klopt hij
       niet, dan is dat geen detail om te verbergen. */
    var rec = d.reconcile || { ok: true };
    var slot = rec.ok
      ? '<p class="hint">The top line is your confirmed balance: <b style="color:var(--tx)">' +
        money(t.confirmedBalanceCents) + '</b>. ' +
        (t.pendingCents ? money(t.pendingCents) + ' is still inside the refund window and is not counted yet. ' : '') +
        (t.requestedCents ? money(t.requestedCents) + ' is reserved for a payout you requested. ' : '') +
        'Available to withdraw: <b style="color:var(--tx)">' + money(t.availableCents) + '</b>.</p>'
      : '<div class="lockrow" style="margin-top:12px;color:var(--mag)">' + svg('alert') +
        '<span><b>These numbers do not add up.</b> The statement totals ' + money(rec.statementAvailableCents) +
        ' but your balance shows ' + money(rec.summaryAvailableCents) +
        ' — a difference of ' + money(Math.abs(rec.differenceCents)) + '. ' +
        'Please contact us before requesting a payout; we would rather fix this than pay the wrong amount.</span></div>';

    var afgekapt = (d.ledgerTruncated || lines.length > 60)
      ? '<p class="hint">Showing the most recent ' + Math.min(60, lines.length) + ' movements' +
        (d.ledgerOrders ? ' of ' + d.ledgerOrders + ' orders' : '') +
        '. Older entries still count towards your balance.</p>'
      : '';

    return '<div class="card" style="margin-top:16px">' +
      '<div class="card__h"><h3>Statement</h3>' +
        '<span class="mini">every movement, newest first</span></div>' +
      '<div class="card__b" style="padding:6px 6px 14px;overflow-x:auto">' +
        '<table><thead><tr><th>Date</th><th>What</th><th>Reference</th>' +
        '<th class="num">Order</th><th class="num">Rate</th>' +
        '<th class="num">Amount</th><th class="num">Balance</th><th>Status</th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>' +
        '<div style="padding:0 12px">' + slot + afgekapt + '</div>' +
      '</div></div>';
  }

  function breakdownHtml(d) {
    var regels = [
      ['Confirmed', d.earnedCents || 0, 'past the refund window', 'var(--green)'],
      ['Holding', d.pendingCents || 0, 'inside the ' + (d.clearDays || 14) + '-day refund window', 'var(--amber)'],
      ['Adjustments', d.adjustmentCents || 0, 'manual corrections by us', 'var(--ice)'],
      ['Paid out', -(d.paidCents || 0), 'transferred to you', 'var(--dim)']
    ];
    var open = d.pendingRequestCents || 0;
    if (open) regels.push(['Requested', -open, 'awaiting approval', 'var(--amber)']);

    return '<div class="card" style="margin-top:16px">' +
      '<div class="card__h"><h3>Where your money is</h3></div>' +
      '<div class="card__b" style="padding:6px 6px 10px"><table><tbody>' +
      regels.map(function (r) {
        if (r[1] === 0 && r[0] === 'Adjustments') return '';   // geen correcties: niet noemen
        return '<tr><td><b>' + esc(r[0]) + '</b><div class="mini">' + esc(r[2]) + '</div></td>' +
          '<td class="num" style="color:' + r[3] + '">' + signedMoney(r[1]) + '</td></tr>';
      }).join('') +
      '<tr><td><b>Available to withdraw</b><div class="mini">what you can request today</div></td>' +
      '<td class="num"><b style="font-size:15px">' + money(d.availableCents) + '</b></td></tr>' +
      '</tbody></table></div></div>';
  }

  function payoutHistoryHtml(d) {
    var lijst = (d.payouts || []).filter(Boolean);
    if (!lijst.length) {
      return '<div class="card" style="margin-top:16px"><div class="card__h"><h3>Payout history</h3></div>' +
        '<div class="card__b"><p style="text-align:center;color:var(--mute);padding:22px 0;margin:0">' +
        'No payouts yet.<br><span class="hint">Once you request and we transfer, every payment appears here with its reference.</span>' +
        '</p></div></div>';
    }
    return '<div class="card" style="margin-top:16px">' +
      '<div class="card__h"><h3>Payout history</h3>' +
        '<span class="mini">' + lijst.length + ' payment' + (lijst.length === 1 ? '' : 's') + '</span></div>' +
      '<div class="card__b" style="padding:6px 6px 14px;overflow-x:auto"><table>' +
      '<thead><tr><th>Reference</th><th>Requested</th><th>Paid</th><th>Method</th>' +
      '<th class="num">Amount</th></tr></thead><tbody>' +
      lijst.map(function (p) {
        return '<tr><td class="mini">' + esc(p.ref || '—') + '</td>' +
          '<td class="mini">' + esc(fmtDate(p.requestedAt)) + '</td>' +
          '<td class="mini">' + (p.paidAt ? esc(fmtDate(p.paidAt))
            : '<span class="chip chip--warn">' + svg('clock') + 'Pending</span>') + '</td>' +
          '<td class="mini">' + esc(p.method || d.payoutMethod || '—') +
            (p.note ? '<div class="mini">' + esc(p.note) + '</div>' : '') + '</td>' +
          '<td class="num">' + money(p.amountCents) + '</td></tr>';
      }).join('') +
      '</tbody></table>' +
      '<p class="hint" style="padding:0 12px">We never store your bank or Wise details here — only that a payment was made, and its reference.</p>' +
      '</div></div>';
  }

  function performanceHtml(d) {
    var items = [
      ['Orders', String(d.orderCount || 0), 'attributed to your code'],
      ['Average order', money(d.avgOrderCents), 'qualifying revenue per order'],
      ['Average commission', money(d.avgCommissionCents), 'what you earn per order'],
      ['Best month', d.bestMonth ? money(d.bestMonth.commissionCents) : '—',
        d.bestMonth ? fmtMonthShort(d.bestMonth.month) : 'no orders yet']
    ];
    var mijlpalen = [];
    if (d.startedAt) mijlpalen.push('Partner since ' + fmtDate(d.startedAt));
    if (d.firstOrderAt) mijlpalen.push('first sale ' + fmtDate(d.firstOrderAt));
    if (d.lastOrderAt) mijlpalen.push('most recent ' + fmtDate(d.lastOrderAt));

    return '<div class="card" style="margin-top:16px">' +
      '<div class="card__h"><h3>Your performance</h3></div>' +
      '<div class="card__b" style="padding:6px 6px 10px"><table><tbody>' +
      items.map(function (x) {
        return '<tr><td><b>' + esc(x[0]) + '</b><div class="mini">' + esc(x[2]) + '</div></td>' +
          '<td class="num" style="font-size:15px">' + x[1] + '</td></tr>';
      }).join('') +
      '</tbody></table>' +
      (mijlpalen.length ? '<p class="hint" style="padding:0 12px">' + esc(mijlpalen.join(' · ')) + '.</p>' : '') +
      '</div></div>';
  }

  function dashHtml(d) {
    /* Volgorde volgt de vragen die een partner stelt, in die volgorde:
       mag ik uitbetalen · hoeveel heb ik · waar is het · klopt het · hoe doe
       ik het · hoe kom ik verder. Het afschrift staat bewust dicht bij het
       saldo: daar wordt het natelbaar. */
    /* Brede tabellen staan op volle breedte. In een kolom van 430px klapt de
       tabel-CSS om naar kaartjes per rij, en dan valt juist het lopende saldo
       uit elkaar — precies de kolom waarvoor het afschrift bestaat. */
    return '<div class="spx__dash">' +
      whoHtml(d) +
      '<div id="spxNotice">' + noticeHtml() + '</div>' +
      bannerHtml(d) +
      tilesHtml(d) +
      '<div class="grid2">' +
        '<div>' + tierCardHtml(d) + performanceHtml(d) + '</div>' +
        '<div>' + payoutCardHtml(d) + breakdownHtml(d) + codeCardHtml(d) + sparkHtml(d) + '</div>' +
      '</div>' +
      statementCardHtml(d) +
      payoutHistoryHtml(d) +
    '</div>';
  }

  function noticeHtml() {
    if (!store.notice) return '';
    var n = store.notice;
    return '<div class="spx__note spx__note--' + n.type + '" ' +
      (n.type === 'err' ? 'role="alert"' : 'role="status"') + ' style="margin-bottom:20px">' + n.html + '</div>';
  }

  /* ── overeenkomst + tekenflow (fase 3) ─────────────────────────────── */

  function countryOptions(sel) {
    return COUNTRIES.map(function (c) {
      return '<option' + (c === sel ? ' selected' : '') + '>' + esc(c) + '</option>';
    }).join('');
  }

  function signBlock(a, d) {
    /* a.signed betekent: de GELDENDE versie is getekend. Stond dit ooit op
       "heeft ooit getekend", dan toonde deze regel "payouts are unlocked"
       terwijl de banner erboven om een nieuwe handtekening vroeg. */
    if (a.signed) {
      return '<div class="sign"><h3 style="font-size:15px;margin-bottom:4px">Signed</h3>' +
        '<p class="sub">You signed version ' + esc(a.signedVersion) + ' on ' +
        esc(fmtDate(a.signedAt)) + (a.signedName ? ' as ' + esc(a.signedName) : '') +
        '. Payouts are unlocked.</p></div>';
    }

    /* Wel eerder getekend, maar op een oudere versie. Zonder deze uitleg
       begrijpt een partner niet waarom er ineens weer iets van hem gevraagd
       wordt terwijl hij netjes had getekend. */
    var eerder = (a.everSigned && a.signedVersion)
      ? '<p class="spx__note spx__note--hold" role="status" style="margin:0 0 14px">' +
        'You signed version ' + esc(a.signedVersion) +
        (a.signedAt ? ' on ' + esc(fmtDate(a.signedAt)) : '') +
        '. Version ' + esc(a.currentVersion || a.version || '') +
        ' has since been published and needs a new signature. ' +
        'Commission you already earned is unaffected — it stays on your balance.</p>'
      : '';
    var err = (store.signErrors && store.signErrors.length)
      ? '<p class="spx__note spx__note--err" role="alert" style="margin:4px 0 12px">' +
        store.signErrors.map(esc).join(' ') + '</p>'
      : '';
    return '<div class="sign">' + eerder +
      '<h3 style="font-size:15px;margin-bottom:4px">' +
        (a.everSigned ? 'Sign the new version' : 'Sign this agreement') + '</h3>' +
      '<p class="sub" style="margin-bottom:16px">All fields except company and VAT are required. ' +
      'Payouts unlock immediately after signing.</p>' +
      '<div class="sign__row">' +
        '<label class="f"><span>Full legal name</span>' +
          '<input class="f sigfont" id="sgName" value="' + esc(d.firstName || '') + '"></label>' +
        '<label class="f"><span>Company / trading name (optional)</span>' +
          '<input class="f" id="sgCompany" placeholder="PeptideLab BV"></label>' +
      '</div>' +
      '<div class="sign__row">' +
        '<label class="f"><span>Country of residence</span>' +
          '<select class="f" id="sgCountry">' + countryOptions() + '</select></label>' +
        '<label class="f"><span>VAT / tax number (if applicable)</span>' +
          '<input class="f" id="sgVat" placeholder="NL123456789B01"></label>' +
      '</div>' +
      '<label class="ack"><input type="checkbox" id="sgAgree">' +
        '<span>I have read and agree to the Affiliate Partner Agreement v' + esc(a.version) + ' in full.</span></label>' +
      /* De termijn komt uit de instellingen, niet uit deze regel. Stond hier
         "90 days" hardgecodeerd; wijzig je exclusivity_tail_days, dan bevestigt
         de partner een termijn die nergens meer mee klopt — in het vakje dat
         later als bewijs dient. Weet de worker het niet, dan verwijzen we naar
         de clausule in plaats van een getal te verzinnen. */
      '<label class="ack"><input type="checkbox" id="sgExcl"><span><b>Exclusivity:</b> I confirm I do not ' +
        'promote, and will not promote, any other peptide or research-chemical brand while this Agreement ' +
        'is in force, and ' + (a.exclusivityTailDays != null
          ? 'for ' + esc(a.exclusivityTailDays) + ' days after it ends'
          : 'for the period stated in clause 2 after it ends') + '.</span></label>' +
      '<label class="ack"><input type="checkbox" id="sgResearch"><span>I understand these products are for ' +
        'laboratory research only, and I will make no human-use, dosing or health claims.</span></label>' +
      err +
      '<div class="sign__foot">' +
        '<button type="button" class="btn" data-act="sign"' + (store.signing ? ' disabled' : '') + '>' +
          svg('check') + ' ' + (store.signing ? 'Signing…' : 'Sign and accept') + '</button>' +
        '<div class="sign__meta">Signed as: ' + esc(d.code || '') + '<br>Recorded: version, timestamp, IP address</div>' +
      '</div>' +
    '</div>';
  }

  function agreementHtml() {
    var a = store.agreement, d = store.data || {};
    if (!a) {
      return '<div class="spx__dash">' + whoHtml(d) +
        '<div class="spx__card"><div class="spx__skel" style="width:40%;height:24px"></div>' +
        '<div class="spx__skel" style="width:80%"></div><div class="spx__skel" style="width:65%"></div></div></div>';
    }
    /* Drie standen, want "ooit getekend" en "nu getekend" zijn niet hetzelfde.
       De middelste stand ontbrak, en dan valt hij noodgedwongen in de
       verkeerde: groen SIGNED terwijl er getekend moet worden. */
    var chip = a.signed
      ? '<span class="chip chip--good">' + svg('check') + 'Signed</span>'
      : (a.everSigned
          ? '<span class="chip chip--warn">' + svg('alert') + 'New version — signature required</span>'
          : '<span class="chip chip--warn">' + svg('alert') + 'Unsigned</span>');
    return '<div class="spx__dash">' +
      '<button type="button" class="btn btn--ghost btn--sm" data-act="back" style="margin-bottom:16px">' +
        '&larr; Back to dashboard</button>' +
      '<div id="spxNotice">' + noticeHtml() + '</div>' +
      '<div class="doc">' +
        '<div class="doc__top">' +
          '<div><div class="eyebrow"><span class="dot"></span>Required before payout</div>' +
            '<h2>Affiliate Partner Agreement</h2>' +
            '<p class="sub">Read in full, then sign at the bottom.</p></div>' +
          '<div style="text-align:right">' +
            '<div class="doc__ver">VERSION ' + esc(a.version) + '</div>' +
            '<div class="doc__ver">EFFECTIVE ' + esc(a.effectiveFrom) + '</div>' +
            '<div style="margin-top:8px">' + chip + '</div></div>' +
        '</div>' +
        '<div class="doc__scroll">' + a.bodyHtml + '</div>' +
        signBlock(a, d) +
      '</div>' +
    '</div>';
  }

  function render() {
    if (store.load === 'error') return renderError();
    if (!store.data) return skeleton();
    root.innerHTML = (store.view === 'agreement') ? agreementHtml() : dashHtml(store.data);
  }


  /* ── de getekende overeenkomst als PDF ───────────────────────────────
     Geen PDF-bibliotheek in de worker: die weegt honderden kilobytes, moet
     lettertypen insluiten, en levert een document dat niemand kan doorzoeken.
     In plaats daarvan een schone printweergave in een eigen venster. Elke
     browser maakt daar met één klik een PDF van, met werkende tekstselectie
     en zoekfunctie — en het is voor de partner dezelfde handeling.

     Het bewijsblok gaat mee: versie, naam, datum, IP en de bevestigingen. Dat
     is wat een getekend exemplaar bruikbaar maakt; een kale tekst zonder
     handtekeninggegevens is alleen een kopie van de voorwaarden. */

  function downloadAgreement() {
    var a = store.agreement;
    if (!a || !a.bodyHtml) {
      /* Tekst nog niet opgehaald. Wél ophalen, maar níet van scherm wisselen:
         je vroeg om een download, niet om de overeenkomst te openen. */
      return api('agreementCurrent').then(function (res) {
        if (res && !res.error && res.bodyHtml) { store.agreement = res; downloadAgreement(); }
        else {
          store.notice = { type: 'err', html: 'Could not load the agreement text' +
            (res && res.error ? ' (' + esc(res.error) + ')' : '') + '. Please try again.' };
          render();
        }
      });
    }

    var d = store.data || {};
    /* Géén 'noopener' hier. Met die vlag geeft window.open volgens de
       specificatie altijd null terug — er is dan geen venster om de tekst in te
       schrijven, en de controle hieronder maakte daarvan "je browser blokkeerde
       het venster". Deze knop heeft dus nooit gewerkt: elke partner die zijn
       getekende exemplaar wilde downloaden kreeg een blokkade te zien die er
       niet was. We openen een leeg venster van dezelfde herkomst en schrijven
       er onze eigen tekst in; opener halen we voor de zekerheid daarna weg. */
    var w = window.open('', '_blank');
    if (!w) {
      store.notice = { type: 'err', html: 'Your browser blocked the print window. ' +
        'Allow pop-ups for this page and try again.' };
      return render();
    }
    try { w.opener = null; } catch (e) {}

    var bewijs = a.signed
      ? '<section class="ev"><h2>Signature record</h2><dl>' +
        '<dt>Version</dt><dd>v' + esc(a.signedVersion || a.version || '') + '</dd>' +
        '<dt>Signed by</dt><dd>' + esc(a.signedName || d.firstName || '') + '</dd>' +
        '<dt>Account</dt><dd>' + esc(d.email || '') + '</dd>' +
        '<dt>Affiliate code</dt><dd>' + esc(d.code || '') + '</dd>' +
        '<dt>Signed at</dt><dd>' + esc(a.signedAt || '') + '</dd>' +
        (a.signedIp ? '<dt>IP address</dt><dd>' + esc(a.signedIp) + '</dd>' : '') +
        '<dt>Acknowledged</dt><dd>agreement · exclusivity · research-use only</dd>' +
        '</dl></section>'
      : '<section class="ev ev--unsigned"><h2>Not signed</h2>' +
        '<p>This is the current text of the agreement. You have not signed it yet, ' +
        'so this copy is for reading only.</p></section>';

    /* Eigen, minimale opmaak: de portal-CSS is voor een donker scherm, en dat
       drukt af als een zwart vlak. Papier is wit. */
    var doc = '<!doctype html><html lang="en"><head><meta charset="utf-8">' +
      '<title>SURGE Pept — Affiliate Partner Agreement v' + esc(a.version || '') + '</title>' +
      '<style>' +
      'body{font:14px/1.65 Georgia,"Times New Roman",serif;color:#111;max-width:46em;margin:0 auto;padding:36px 28px}' +
      'h1{font-size:22px;margin:0 0 4px}h2{font-size:15px;margin:26px 0 8px}h4{font-size:14px;margin:22px 0 6px}' +
      '.meta{color:#555;font-size:12px;margin-bottom:26px;border-bottom:1px solid #ccc;padding-bottom:14px}' +
      'p{margin:0 0 11px}li{margin-bottom:6px}' +
      'table{width:100%;border-collapse:collapse;margin:12px 0;font-size:13px}' +
      'th,td{border:1px solid #bbb;padding:6px 9px;text-align:left}' +
      '.hl{border-left:3px solid #111;padding-left:12px;margin:14px 0}' +
      '.ev{margin-top:32px;border:1px solid #999;padding:14px 16px;break-inside:avoid}' +
      '.ev h2{margin-top:0}.ev dl{display:grid;grid-template-columns:auto 1fr;gap:5px 16px;margin:0;font-size:13px}' +
      '.ev dt{color:#555}.ev dd{margin:0}' +
      '.ev--unsigned{border-style:dashed}' +
      '@media print{body{padding:0}.noprint{display:none}}' +
      '.noprint{margin-top:28px;border-top:1px solid #ccc;padding-top:14px;font-size:12px;color:#555}' +
      '</style></head><body>' +
      '<h1>Affiliate Partner Agreement</h1>' +
      '<div class="meta">SURGE Pept · version ' + esc(a.version || '') +
        (a.effectiveFrom ? ' · effective from ' + esc(a.effectiveFrom) : '') +
        ' · retrieved ' + esc(new Date().toISOString().slice(0, 10)) + '</div>' +
      a.bodyHtml +
      bewijs +
      '<div class="noprint">Use your browser&rsquo;s print dialog and choose ' +
      '&ldquo;Save as PDF&rdquo; to keep a copy.</div>' +
      '</body></html>';

    w.document.write(doc);
    w.document.close();
    /* Even wachten tot de opmaak staat; anders drukt Safari een lege pagina af. */
    setTimeout(function () { try { w.focus(); w.print(); } catch (e) {} }, 350);
  }

  function openAgreement() {
    store.view = 'agreement';
    store.notice = null;
    store.signErrors = [];
    render();
    try { window.scrollTo(0, 0); } catch (e) {}
    if (!store.agreement) {
      api('agreementCurrent').then(function (res) {
        if (res && !res.error) { store.agreement = res; render(); }
      }).catch(function () {});
    }
  }

  function doSign() {
    var input = {
      name:    (h('sgName')    || {}).value || '',
      company: (h('sgCompany') || {}).value || '',
      country: (h('sgCountry') || {}).value || '',
      vat:     (h('sgVat')     || {}).value || '',
      acks: []
    };
    if (h('sgAgree')    && h('sgAgree').checked)    input.acks.push('agree');
    if (h('sgExcl')     && h('sgExcl').checked)     input.acks.push('exclusivity');
    if (h('sgResearch') && h('sgResearch').checked) input.acks.push('research');

    var errs = [];
    if (!String(input.name).trim())    errs.push('Enter your full legal name.');
    if (!String(input.country).trim()) errs.push('Select your country of residence.');
    if (input.acks.length < 3)         errs.push('Tick all three confirmations, including exclusivity.');
    if (errs.length) { store.signErrors = errs; render(); return; }

    store.signErrors = []; store.signing = true; render();
    api('agreementSign', { signature: input }).then(function (res) {
      store.signing = false;
      if (res && res.signed) {
        store.data = res;
        store.agreement = null;        // volgende keer vers ophalen (getekende staat)
        store.view = 'dashboard';
        store.notice = { type: 'ok', html: 'Agreement signed — your payouts are unlocked.' };
        render(); try { window.scrollTo(0, 0); } catch (e) {}
      } else if (res && res.error === 'invalid_signature') {
        store.signErrors = ['Please complete all required fields and confirmations.'];
        render();
      } else {
        store.signErrors = ['Signing did not go through. Please try again or get in touch.'];
        render();
      }
    }).catch(function () {
      store.signing = false;
      store.signErrors = ['No connection to the server. Please try again.'];
      render();
    });
  }

  /* ── acties ────────────────────────────────────────────────────────── */

  function copyText(val, btn) {
    function done() {
      var old = btn.textContent;
      btn.textContent = 'Copied';
      btn.classList.add('btn--ghost');
      setTimeout(function () { btn.textContent = old; }, 1700);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(val).then(done, function () { fallback(val, done); });
    } else { fallback(val, done); }
  }
  function fallback(val, done) {
    var ta = document.createElement('textarea');
    ta.value = val; ta.setAttribute('readonly', '');
    ta.style.position = 'absolute'; ta.style.left = '-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); done(); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* Partner meldt dat het formulier gemaild is. Ontgrendelt niets; zet de
     regel in het paneel op 'ter controle'. */
  function declareTaxSent(btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
    api('taxFormDeclareSent').then(function (res) {
      if (res && res.declared) {
        store.data = res;
        store.notice = { type: 'ok', html: 'Thanks — we’ve noted that your tax form is on its way. ' +
          'We’ll unlock payouts once we’ve checked it.' };
      } else {
        store.notice = { type: 'err', html: 'Could not save that. Please try again.' };
      }
      render();
    }).catch(function () {
      store.notice = { type: 'err', html: 'No connection to the server. Please try again.' };
      render();
    });
  }

  function requestPayout() {
    if (!store.armed) {
      store.armed = true;
      render();
      setTimeout(function () { if (store.armed) { store.armed = false; render(); } }, 8000);
      return;
    }
    store.armed = false;
    store.busy = true;
    api('requestPayout').then(function (res) {
      store.busy = false;
      if (res && res.requested) {
        store.notice = { type: 'ok', html: 'Payout requested. Reference <b>' + esc(res.ref) +
          '</b> for ' + money(res.amountCents) + '. You will hear from us as soon as it has been processed.' };
        if (res.code) store.data = res;
      } else if (res && res.error === 'request_already_open') {
        store.notice = { type: 'err', html: 'There is already an open payout request.' };
        if (res.code) store.data = res;
      } else if (res && res.message) {
        /* Server-side grendel (agreement_unsigned/outdated/inactive/below_minimum):
           toon de leesbare reden die de worker teruggeeft. */
        store.notice = { type: 'err', html: esc(res.message) };
        if (res.code) store.data = res;
      } else {
        store.notice = { type: 'err', html: 'The request did not go through. Please try again later or get in touch.' };
      }
      render();
    }).catch(function () {
      store.busy = false;
      store.notice = { type: 'err', html: 'No connection to the server. Please try again later.' };
      render();
    });
  }

  /* ── snelheid ──────────────────────────────────────────────────────────
     De worker doet twee Shopify-rondjes (klant, orders) voordat hij kan
     antwoorden; dat duurt merkbaar. In plaats van al die tijd een skelet te
     tonen, bewaren we de laatste weergave per klant in sessionStorage en
     tekenen die meteen, terwijl de verse gegevens op de achtergrond binnenkomen.
     Alleen deze sessie, alleen deze klant, en het is de eigen data van de
     partner — er lekt niets naar een andere gebruiker. */
  var CACHE_KEY = 'spx.me.' + (CFG.cid || '0');
  var CACHE_MAX_AGE_MS = 10 * 60 * 1000;

  function cacheRead() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var box = JSON.parse(raw);
      if (!box || !box.at || (Date.now() - box.at) > CACHE_MAX_AGE_MS) return null;
      return box.data || null;
    } catch (e) { return null; }
  }
  function cacheWrite(data) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data: data })); }
    catch (e) {}
  }

  function load(isRefresh) {
    if (!isRefresh) { store.load = 'loading'; skeleton(); }
    return api('summary').then(function (d) {
      if (!d || d.error) {
        /* Toonden we gecachte gegevens? Dan die laten staan en alleen melden
           dat verversen mislukte — beter dan een werkend scherm weggooien. */
        if (store.data && store.fromCache) {
          store.notice = { type: 'hold', html: 'Could not refresh just now — showing your last known figures.' };
          return render();
        }
        store.load = 'error'; store.error = d || {}; return renderError();
      }
      store.data = d;
      store.fromCache = false;
      store.fetchedAt = new Date();
      store.load = 'ok';
      cacheWrite(d);
      try { sessionStorage.removeItem('spx.reloads'); } catch (e) {}
      render();
    }).catch(function () {
      if (store.data && store.fromCache) {
        store.notice = { type: 'hold', html: 'Could not refresh just now — showing your last known figures.' };
        return render();
      }
      store.load = 'error';
      store.error = { error: 'network' };
      renderError();
    });
  }

  function renderError() {
    var e = store.error || {};
    /* Alles wat we weten in de console, ook zonder `version` — bij een
       foutpagina is er immers geen worker-antwoord om een versie uit te
       halen, en juist dán wil je de details kunnen teruglezen. */
    if (window.console && console.warn) {
      console.warn('[SURGE Pept portal] error: ' + (e.error || 'unspecified') +
        (e.version ? ' — worker ' + e.version : '') +
        (e.httpStatus ? ' — HTTP ' + e.httpStatus : '') +
        (e.step ? ' — step: ' + e.step : '') +
        (e.contentType ? ' — content-type: ' + e.contentType : '') +
        (e.message || e.reason || e.bodySnippet ? ' — ' + (e.message || e.reason || e.bodySnippet) : ''));
    }
    if (e.error === 'not_an_affiliate') {
      return fullMsg('You are not part of the programme yet',
        'This account does not have an affiliate code yet. Get in touch if you would like to join.',
        '<a class="spx__b spx__b--go" href="/pages/contact">Contact us</a>');
    }
    if (e.error === 'rate_limited') {
      return fullMsg('One moment', 'You refreshed too quickly. Please try again in a minute.',
        '<button type="button" class="spx__b" data-act="retry">Try again</button>');
    }
    if (e.error === 'signature_expired') {
      return fullMsg('Your session expired',
        'For security, this page refreshes after 30 minutes of inactivity. Reload to continue.',
        '<button type="button" class="spx__b spx__b--go" data-act="reload">Reload</button>');
    }
    var explain = {
      bad_signature: 'The secret in this section and the one in Cloudflare do not match.',
      unauthenticated: 'No valid customer ID came through from Shopify.',
      shopify_lookup_failed: 'The worker could not reach Shopify: ' + (e.reason || ''),
      bad_request: 'The worker did not understand the request.',
      /* De worker gaf JSON terug over zijn eigen storing, inclusief de stap
         waarin het misging. Die tonen we: "server error during Shopify:
         orders ophalen" is te plaatsen, "the server did not respond" niet. */
      server_error: 'The server hit an error' + (e.step ? ' during: ' + e.step : '') +
        (e.message ? ' (' + e.message + ')' : '') + '.',
      /* Er kwám een antwoord, maar geen JSON — meestal een foutpagina van een
         laag ertussen. Status en contenttype maken duidelijk welke laag. */
      bad_response: 'The server replied with ' + (e.contentType || 'something unexpected') +
        ' instead of data (HTTP ' + (e.httpStatus || '?') + ')' +
        (e.bodySnippet ? ': ' + e.bodySnippet : '') + '.',
      /* Alleen dit is echt "geen antwoord". */
      network: 'No response from the server' + (e.reason ? ' (' + e.reason + ')' : '') +
        '. Check your internet connection.'
    }[e.error] || ('Unknown error: ' + (e.error || 'unspecified') +
      (e.httpStatus ? ' (HTTP ' + e.httpStatus + ')' : '') +
      (e.message ? ' — ' + e.message : ''));
    fullMsg('We could not load your data', explain,
      '<button type="button" class="spx__b" data-act="retry">Try again</button>' +
      '<a class="spx__b spx__b--ghost" href="/pages/contact">Contact us</a>');
  }

  /* ── events, via delegatie ─────────────────────────────────────────── */

  root.addEventListener('click', function (ev) {
    var el = ev.target.closest ? ev.target.closest('[data-act]') : null;
    if (!el || !root.contains(el)) return;
    var act = el.getAttribute('data-act');

    if (act === 'copylink') { copyText(shareLink(), el); }
    else if (act === 'taxsent') { declareTaxSent(el); }
    else if (act === 'payout') { requestPayout(); }
    else if (act === 'review') { openAgreement(); }
    else if (act === 'sign') { doSign(); }
    else if (act === 'back') {
      store.view = 'dashboard'; store.notice = null; store.signErrors = [];
      render(); try { window.scrollTo(0, 0); } catch (e) {}
    }
    else if (act === 'retry') { load(false); }
    else if (act === 'reload') { location.reload(); }
    else if (act === 'pdf') { downloadAgreement(); }
    else if (act === 'noop') { /* placeholder-actie uit de mockup */ }
  });

  /* ── start ─────────────────────────────────────────────────────────── */

  if (!CFG.loggedIn) {
    fullMsg('Log in to view your portal',
      'Your results are linked to your account. Log in and come back here.',
      '<a class="spx__b spx__b--go" href="/account/login">Log in</a>');
    return;
  }

  /* Zelfherstel bij een verlopen handtekening: de handtekening uit Liquid is
     30 minuten geldig. In plaats van een foutmelding verversen we de pagina
     zodra de tab weer actief wordt én de handtekening tegen zijn houdbaarheid
     aan loopt — dat valt samen met het moment waarop er toch niet gekeken
     wordt. 25 min i.p.v. 30 laat ruimte voor het laden en klokafwijking. */
  var SIGNATURE_STALE_MS = 25 * 60 * 1000;
  var signedAtMs = (parseInt(CFG.ts, 10) || 0) * 1000;
  var reloading = false;
  function signatureStale() {
    return signedAtMs ? (Date.now() - signedAtMs) > SIGNATURE_STALE_MS : false;
  }
  document.addEventListener('visibilitychange', function () {
    if (reloading || document.visibilityState !== 'visible' || !signatureStale()) return;
    var tries = 0;
    try { tries = parseInt(sessionStorage.getItem('spx.reloads') || '0', 10) || 0; } catch (e) {}
    if (tries >= 2) return;
    try { sessionStorage.setItem('spx.reloads', String(tries + 1)); } catch (e) {}
    reloading = true;
    location.reload();
  });

  /* Directe weergave uit de cache, daarna stil verversen. Zonder cache
     (eerste bezoek) valt hij terug op het skelet. */
  var cached = cacheRead();
  if (cached) {
    store.data = cached;
    store.fromCache = true;
    store.load = 'ok';
    render();
    load(true);
  } else {
    load(false);
  }
})();
